/**
 * Get the marketing-site origin (e.g. https://rxrooster.com).
 *
 * Public share links (/s/:token) must point at the marketing site, NOT the app
 * origin (app.rxrooster.com). The app origin returns 400 to link-preview
 * crawlers and is client-rendered, so it cannot serve an Open Graph preview.
 * The marketing /s/[token] route renders the OG card for crawlers and redirects
 * humans back to the app. The backend builds share URLs from MARKETING_SITE_URL
 * for the same reason; this is the frontend equivalent for the rare paths that
 * construct a share URL client-side.
 *
 * Resolution order:
 *   1. REACT_APP_MARKETING_URL build-time override (trailing slash stripped)
 *   2. Derive from the current host: strip a leading "app." so the platform host
 *      maps to its marketing root (app.rxrooster.com to rxrooster.com). localhost
 *      uses the marketing dev server on :3002.
 *   3. https://rxrooster.com fallback (non-browser contexts)
 *
 * @returns {string} Marketing origin without a trailing slash
 */
export const getMarketingOrigin = () => {
  const envUrl = process.env.REACT_APP_MARKETING_URL;
  if (envUrl) {
    return envUrl.replace(/\/+$/, '');
  }

  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname
  ) {
    const host = window.location.hostname.toLowerCase();
    const protocol = window.location.protocol || 'https:';

    // Local dev: the marketing Next.js server runs on :3002.
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:3002';
    }

    // app.rxrooster.com to rxrooster.com. test.rxrooster.com stays as-is
    // (there is no separate marketing staging deploy).
    const marketingHost = host.replace(/^app\./, '');
    return `${protocol}//${marketingHost}`;
  }

  return 'https://rxrooster.com';
};

export default getMarketingOrigin;
